/*
 * Date: 2025
 * Description: Fetch api logics..
 * Author: Philippe Leroux @ skitsc
 */

//Utilities functions
import { emptyPromise } from "../utils/utility";

//Interfaces and types
import { t_method , t_credentials } from "../types/types";
import { i_promise, i_script_entry } from "../interfaces/utility.interface";
import { handleReconnect } from "../context/socket.context";
import { i_models } from "../interfaces/items.interface";

const api_url = ( process.env.REACT_APP_API_URL || '' ) + process.env.REACT_APP_PREPATH
const ENV = process.env.REACT_APP_ENV || 'development'

const composeHeaders = ( method : 'POST' | 'DELETE' | 'GET' | 'PUT' | 'PATCH', creds : t_credentials , body : any ) => {
    var options;
    var head : HeadersInit = {}
    if(creds === 'include'){
        head = new Headers ({ "accept": "application/json", "content-type": "application/json", "credentials": "include", })
        options = { method: method, credentials : creds, headers: head, body : body == null ? null : JSON.stringify(body) }
    }else{
        head = new Headers({ "accept": "application/json", "content-type": "application/json", })
        options = { method: method, headers: head, credentials : undefined, body : body == null ? null : JSON.stringify(body) }
    }
    return options;
}

const handleFetch = async (url : string , method : t_method , cred : boolean, body : any ) : Promise<i_promise> => {
    const empty_promise : i_promise = emptyPromise();
    var creds : t_credentials = 'include'
    if(!cred) creds = 'omit'
    const headers = composeHeaders( method , creds , body) 
    try{
        const rep = await fetch(api_url + url, headers)
        .then((response) => { return response.json() }).then((response) => { return response })
        .catch(() => {
            empty_promise.type = 'Failed'
            empty_promise.message = 'Unable to fetch api , contact with administrator'
            return empty_promise
        })
        return rep
    }catch(err){
        console.log('Error in handleFetch' , err)
        empty_promise.message = 'Bad request'
        empty_promise.type = 'Bad request'
        return empty_promise
    }finally{
      handleReconnect()
    }
}
const handleGetFile = async (url : string , type : string) : Promise<i_promise> => {
    const empty_promise = emptyPromise();
    try{
        const headers = composeHeaders( 'GET' , 'include' , null) 
        const output = await fetch(api_url + url, headers)
        if(!output.ok){
            empty_promise.type = 'Failed'
            empty_promise.message = 'Unable to fetch file, contact with administrator'
            return empty_promise
        }
        const jsonL = await output.text();
        if(type === 'script'){
            const lines: i_script_entry[] =  jsonL.split('\n').filter(line => line.trim() !== '').map(line => JSON.parse(line)); 
            return {
                type: 'Success',
                message: 'File loaded',
                data: lines
            };
        }else{
            empty_promise.type = 'Failed'
            empty_promise.message = 'Please enter a model type'
            return empty_promise
        }
    }catch(err){
        console.log('Error in handleGetFile' , err)
        return empty_promise
    }
}

const handleLogout = async () : Promise<i_promise> => {
    const empty_promise = emptyPromise();
    try{
        const output = await fetch( api_url + "/logout", { method: 'GET', credentials : 'include', redirect: "follow", headers: { "Accept": "application/json", "Content-Type": "application/json", "credentials" : 'include' }, })
        .then((res) => { return res.json() }).then(( res ) => { return res })
        .catch(err => {
            console.log(err)
            empty_promise.type = 'Error'
            empty_promise.message = 'Api error'
            return empty_promise
        });
        return output
    }catch(err){
        console.log('Error in handleLogout' , err)
        return empty_promise
    }
}
const findModel = async( id : string) : Promise<i_models[]> => {
    const res = await handleFetch('/model/'+id , 'GET', true, null)
    if(res.type === 'Success'){
        return res.data
    }else{
        return []
    }
}
export {
  handleLogout,
  handleFetch,
  findModel,
  ENV,
  handleGetFile
};